__turbopack_context__.v({
  "bentoDesktop": "cT24Aq_bentoDesktop",
  "bentoMobile": "cT24Aq_bentoMobile",
  "root": "cT24Aq_root",
});
